import { HTMLWidget, ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";

interface Props {
  title?: string;
  safeStoreIcons?: SafeStoreIcon[];
}

export interface SafeStoreIcon {
  image: ImageWidget;
  name?: string;
  link?: string;
  html?: HTMLWidget;
  width?: number;
  height?: number;
}

function SafeStore({ title, safeStoreIcons }: Props) {
  return (
    <div className="flex flex-col items-center xl:flex-row">
      {title && (
        <h3 className="font-['Poppins'] not-italic font-medium leading-[14px] tracking-[0.06em] uppercase text-sm text-black mb-2.5 xl:mb-0">
          {title}
        </h3>
      )}
      {safeStoreIcons && safeStoreIcons.length
        ? (
          <ul className="flex flex-row flex-wrap items-center justify-center gap-2.5 xl:ml-[30px]">
            {safeStoreIcons.map(
              ({ name, image, link, width, height, html }) => {
                const icon = (
                  <Image
                    loading="lazy"
                    fetchPriority="low"
                    width={width ?? 65}
                    height={height ?? 65}
                    src={image}
                    alt={name}
                  />
                );

                return (
                  <li title={name}>
                    {image && (link ? <a href={link}>{icon}</a> : icon)}
                    {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
                  </li>
                );
              },
            )}
          </ul>
        )
        : <></>}
    </div>
  );
}

export default SafeStore;
